// extracted by mini-css-extract-plugin
module.exports = {"partnerListItemWrapper":"djp65","partnerListItem":"_7Vfk3","partnerListItemDescription":"PpslV","descriptionTextWrapper":"SKptz","partnerMaskWrapper":"ly-2s"};